import { CountUp } from './countUp.js';

const numberCounter = {

       

    init () {

        let numberList = document.getElementsByClassName("number");
        let numberListType = document.getElementsByClassName("numbertype");
        
       
       
        function containsOnlyNumbers(str) {
            return /^[0-9]+$/.test(str);
        }

        function numberWithSpaces(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
        
        
         if (numberList.length > 0) {

            window.addEventListener("load", (event) => {
                let savedValue1 = (numberList[0].innerHTML);
                let savedValue2 = (numberList[1].innerHTML);
                let savedValue3 = (numberList[2].innerHTML);


                const options = {
                    duration: 4.5,
                      separator: ' ',
                      decimal: '',   
                    enableScrollSpy: true,
                    scrollSpyOnce: true,
                };

                const options2 = {
                    duration: 4.5,
                      separator: '',
                      decimal: '',   
                    enableScrollSpy: true,
                    scrollSpyOnce: true,
                };

                if(containsOnlyNumbers(numberList[0].innerHTML)) {

                    let counter1 = new CountUp('number', parseInt(numberList[0].innerHTML), options);
                    counter1.start();
        
                } else if(numberList[1].innerHTML == ""){
                    numberList[0].innerHTML = "-";
                    numberListType[0].innerHTML = "";
                }
                
                if(containsOnlyNumbers(numberList[1].innerHTML)) {
                    let counter2 = new CountUp("number2", parseInt(numberList[1].innerHTML), options);
                    counter2.start();
                    
                } else if(numberList[1].innerHTML == ""){
                    numberList[1].innerHTML = "-";
                    numberListType[1].innerHTML = "";
                }
                
                if(containsOnlyNumbers(numberList[2].innerHTML)) {
                    let counter3 = new CountUp("number3", parseInt(numberList[2].innerHTML), options2);
                    counter3.start();

                } else if(numberList[2].innerHTML == ""){
                    numberList[2].innerHTML = "-";
                    numberListType[2].innerHTML = "";
                } else {
                    numberList[2].innerHTML = savedValue3;
                }

            });
        }
    }
}

export default numberCounter;
